import { Skeleton, Form, Input, Button, Select, Divider, Space } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { BottomButtons } from 'components/SharedComponents/BottomButtons/BottomButtons';
import gql from 'graphql-tag';
import { useAuthedMutationWithNotification } from 'utils/qlAuth';
import { ColoredTags_predefinedTags } from 'components/Dashboard/ColoredTags';
import { UniverseController_genStories, UniverseController_removeAllStories } from './buttons';
import { PromtMutatorHelps } from 'components/Help/PromtHelps';

export const UniverseMain = (props: { qUniverse: any; universeId: number }) => {
  const [UniverseController_updateUniverse, updateRes] = useAuthedMutationWithNotification(gql`
    mutation UniverseController_updateUniverse($id: Int!, $config: JSON!) {
      UniverseController_updateUniverse(id: $id, config: $config) {
        id
      }
    }
  `);

  const universe = props.qUniverse.data?.UniverseController_getUniverseById || {};
  if (props.qUniverse.loading || !universe) {
    return <Skeleton active />;
  }

  return (
    <>
      <Form
        layout="vertical"
        initialValues={universe}
        onFinish={async values => {
          const newValues = { ...values };
          await UniverseController_updateUniverse({ variables: { id: Number(props.universeId), config: newValues } });
          props.qUniverse.refetch();
        }}
      >
        <Form.Item label="Type" name={`type`} key={`type`}>
          <Select>
            <Select.Option value="UniverseShortStory">V1: UniverseShortStory</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label="Name" name={`name`} key={`name`}>
          <Input name="name" />
        </Form.Item>
        <Form.Item label="Tags" name="tags" key="tags">
          <Select mode="multiple" allowClear style={{ width: '100%' }} placeholder="Выберите теги" options={ColoredTags_predefinedTags} />
        </Form.Item>
        <Form.Item label="Story promt template" name={`promtTemplate`} help={`Шаблон промта для истории '<promt>' - это место для вставки истории`}>
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item label="Init Message" name={`initMessage`} help={`Истории разделённые ---`}>
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item label="Promt mutator" name={`promtMutator`} help={<PromtMutatorHelps />}>
          <TextArea rows={4} />
        </Form.Item>
        <br />
        <br />
        <br />
        <br />
        <br />
        <BottomButtons
          extra={
            <>
              <UniverseController_removeAllStories qUniverse={props.qUniverse} id={props.universeId} />
            </>
          }
        >
          <Button type="primary" htmlType="submit" size="small" loading={updateRes.loading} disabled={updateRes.loading}>
            Save
          </Button>
          <UniverseController_genStories qUniverse={props.qUniverse} id={Number(props.universeId)} />
        </BottomButtons>
      </Form>
    </>
  );
};
